import { createSlice } from '@reduxjs/toolkit';
import { IAgsValidationErrorsState, IInitAction, IInitResolveAction } from './types';

const initialState: IAgsValidationErrorsState = {
  revisionId: undefined,
  errors: [],
  status: {
    ready: false,
    errorMessage: undefined,
    busyState: false,
  },
};

const slice = createSlice({
  name: 'agsValidationErrorMessages',
  initialState,
  reducers: {
    init: (state, action: IInitAction) => {
      const { payload: { revisionId } = {} } = action;
      state.status.ready = false;
      state.status.errorMessage = undefined;
      state.status.busyState = false;
      state.revisionId = revisionId;
    },
    initResolve: (state, action: IInitResolveAction) => {
      state.errors = action.payload.Errors;
      state.status.ready = true;
    },
    initReject: (state) => {
      state.status.errorMessage = 'Revision could not be found, please check that the ID is correct.';
      state.status.ready = true;
    },
  },
});

export const { actions, reducer } = slice;
export default slice.reducer;
